// In order to use this ArticleMinimalModel entity, make sure you correctly
// require / import the `RoutesService` Angular service in your Angular app

angular
  .module('models.ArticleMinimalModel', [])
  .service('ArticleMinimalModel', [
    'RoutesService',
    function (Routes) {
      return class ArticleMinimal {
        constructor(data) {
          this.title = data.title;
          this.slug_and_id = data.slug_and_id;
          this.id = data.id;
          this.thumbnail = data.thumbnail;
          this.publication_date = data.publication_date;
          this.access_level_id = data.access_level_id;

          this.link = Routes.news_article_path({ slug_and_id: this.slug_and_id });
        }
      };
    }
  ]);
